module.exports = __webpack_public_path__ + "img/jingdou.d0cb3817.png";